import * as React from 'react'
import { Link, Route, RouteComponentProps } from 'react-router-dom'
import Plus from '../icons/organizations/Plus'
import AssistanceList from '../../containers/global-settings/AssistanceList'
import AddAssistanceModal from '../../containers/global-settings/AddAssistanceModal'
import EditAssistanceModal from '../../containers/global-settings/EditAssistanceModal'
import RemoveAssistanceModal from '../../containers/global-settings/RemoveAssistanceModal'
import { GLOBAL_SETTINGS_ASSISTANCE_COLUMN } from '../../state/constants/index'
import BackToList from '../ui/BackToList'

export default class AssistancePane extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <React.Fragment>
        <Route path={`${this.props.match.path}/create`} component={AddAssistanceModal} />
        <Route path={`${this.props.match.path}/remove/:id`} component={RemoveAssistanceModal} />
        <Route path={`${this.props.match.path}/edit/:id`} component={EditAssistanceModal} />
        <BackToList link='/global-settings' className='flex' />
        <div className='pt3'>
          <div className='flex justify-between mb2'>
            <div className='pl3 h3 bold font-blue-grey'>Assistance</div>
            <div className='flex items-center justify-center'>
              <Link
                className='btn bg-green rounded font-white mr2 flex justify-center items-center'
                to='/global-settings/assistance/create'
              >
                <Plus className='svg-white mr1' />
                Add Assistance
              </Link>
            </div>
          </div>
          <hr />
          <div className='pr3 pl3'>
            <div className='flex justify-between pl3'>
              <div className='flex col-12'>
                <div className='col-3'>{GLOBAL_SETTINGS_ASSISTANCE_COLUMN.CATEGORY}</div>
                <div className='col-3'>{GLOBAL_SETTINGS_ASSISTANCE_COLUMN.TYPE}</div>
                <div className='col-4'>{GLOBAL_SETTINGS_ASSISTANCE_COLUMN.INSTRUCTION}</div>
              </div>
            </div>
            <hr />
            <AssistanceList />
          </div>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AssistancePane.tsx